import React from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import * as styles from './Dropdown.css'
import IconCheck from '@/icons/action/iconCheck'

type DropdownOption = {
  link: () => void
  icon?: React.ReactNode
  label: string
  selected?: boolean
}

type DropdownProps = {
  isOpen: boolean
  options: DropdownOption[]
  onOpenChange: () => void
  topDistance?: string
  side?: 'left' | 'right' | 'top' | 'bottom'
  container?: HTMLElement | null
  children?: React.ReactNode
  trigger: React.ReactNode
}

const Dropdown: React.FC<DropdownProps> = ({
  isOpen,
  options,
  onOpenChange,
  topDistance = '30px',
  side = 'left',
  container = null,
  children,
  trigger,
}) => {
  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={onOpenChange} modal={false}>
      <DropdownMenu.Trigger aria-label="Open Dropdown" asChild>
        {trigger}
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal forceMount container={container}>
        <DropdownMenu.Content
          className={`${styles.DropdownContainer} ${isOpen ? styles.Enter : styles.Leave}`}
          sideOffset={10}
          side={side}
          style={{ top: topDistance }}
        >
          {children}
          {options?.map((item, index) => (
            <DropdownMenu.Item
              key={index}
              className={`${styles.DropdownOption} ${item?.selected ? styles.DropdownOptionSelected : ''}`}
              onSelect={item?.link}
            >
              {item.icon && (
                <span className={styles.DropdownIcon}>{item?.icon}</span>
              )}
              <div className={styles.DropdownSpaceBetween}>
                {item?.label}
                {item?.selected && <IconCheck width={20} height={20} />}
              </div>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

export default Dropdown
